import { useParams } from "react-router-dom";
import { useAdmin } from "@/context/AdminContext";
import { BlockArea } from "@/components/cms/BlockArea";
import NotFound from "@/pages/NotFound";

export default function CustomPage() {
  const { slug } = useParams();
  const { pages, pagesLoaded } = useAdmin();
  const page = pages.find((p) => p.slug === slug && !p.builtin);
  if (!page) return pagesLoaded ? <NotFound /> : <div className="min-h-[60vh]" />;
  return (
    <div data-testid={`custom-page-${slug}`} className="min-h-[50vh] pt-10 pb-24 sm:pt-16">
      <BlockArea key={slug} slug={slug} emptyHint="This page is empty. Use Add content to start." />
    </div>
  );
}
